import React from "react";
import { SvgIcon } from "./SvgIcon";
import { nike } from "@nike/nike-design-tokens";
var paletteSuccess = nike.paletteSuccess;
var smallPath = /*#__PURE__*/React.createElement("g", {
  transform: "translate(8,8)"
}, /*#__PURE__*/React.createElement("circle", {
  xmlns: "http://www.w3.org/2000/svg",
  cx: "4",
  cy: "4",
  r: "4",
  fill: paletteSuccess
}));
var paths = {
  s: smallPath,
  m: smallPath,
  l: smallPath
};
export var SuccessIcon = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    paths: paths
  }, props));
});